import { AvailableLanguages } from "../types";
export const languageAvailableLanguageMap = {
    "en": AvailableLanguages.English,
    "en-US": AvailableLanguages.English,
    "ru": AvailableLanguages.Russian,
    "ru-RU": AvailableLanguages.Russian
};
